export default () => ({
    activeTab: '1',

    // Check if a tab URL was used
    async init() {
        this.activeTab = window.location.hash?.replace('#', '') || '1'
    },

    tab: {
        ['@click']() {
            this.activeTab = this.$el.dataset.tab
        },

        [':class']: 'activeTab === $el.dataset.tab ? "--is-active" : ""',
    },

    tabContent: {
        [':class']: 'activeTab === $el.dataset.tab ? "--is-active" : ""',
        // ['x-show']: 'activeTab === $el.dataset.tab',
    },

    // Function available but not used
    open() {
        this.activeTab = this.$el.dataset.tab
    },
})
